import { render } from "./SaleType.vue?vue&type=template&id=29523870"
import script from "./SaleType.vue?vue&type=script&lang=js"
export * from "./SaleType.vue?vue&type=script&lang=js"

import "./SaleType.vue?vue&type=style&index=0&id=29523870&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__